import axios from 'axios';
import React, { useState, useEffect, useMemo, Fragment, useRef, useCallback } from 'react';

import { FormControl, InputLabel, Input, FormHelperText, Alert } from '@mui/material';
import WebService from '@util/webService';
import { encodeParams, getAction, printVariable } from '@util/helper';
// redux
import { useSelector, useDispatch } from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline';
import MUITable from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableFooter from '@mui/material/TableFooter';
// react-table
import { useTable, useExpanded } from 'react-table';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField, withStyles, InputBase } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import '@scss/App.scss';
import Button from '@mui/material/Button';
import FlatButton from '@components/FlatButton';
import useSnackbar from '@hooks/useSnackbar';
import MyTableHead from '@components/MyTableHead';
import useIndicator from '@hooks/useIndicator';
import Indicator from '@components/Indicator';
import MyDialog from '@components/MyDialog';
import useForm from '@hooks/useForm';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
// pagination
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Paper from '@mui/material/Paper';
import moment from 'moment';
import { Avatar, Grid, Container } from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
// date
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/ko';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { searchSchool } from '@util/helper';
import GdnLecturePartRegi from './gdn-lecture.part.regi';

const Boxs = styled(Box)`
  padding-bottom: 40px !important;
`;

const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

const RLTN_CODE = 'S003';
const GdnLecturePage = () => {
  console.log('GdnLecturePage rendering...');
  const g_sel_code = 'SA07';
  const g_stat_code = 'SA08';
  const g_week_code = 'SB07';

  const inputRef = useRef();
  const dateFormat = 'YYYY-MM-DD HH:mm:ss';
  const [detailScreen, set_detailScreen] = useState(false);
  const [smstList, set_smstList] = useState([]);
  const [selCodeList, set_selCodeList] = useState([]);
  const [statCodeList, set_statCodeList] = useState([]);
  const [weekCodeList, set_weekCodeList] = useState([]);
  const [open, set_open] = useState(false)
  const [studentList, set_studentList] = useState([])
  const smstRef = useRef(null)

  const fields = [
    { field: 'id', placeholder: '아이디', type: 'text', value: -1, visible: false, canSrch: false, selList: [] },
    { field: 'userId', placeholder: '강사명', type: 'select', value: -1, visible: detailScreen, canSrch: false, selList: [] },
    { field: 'title', placeholder: '강좌 제목', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'teacherName', placeholder: '강사명', type: 'text', value: '', visible: !detailScreen, canSrch: false, selList: [] },
    { field: 'weekCode', placeholder: '요일', type: 'checkbox', value: '', visible: false, canSrch: false, selList: weekCodeList },
    { field: 'loc', placeholder: '장소', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'rcrNum', placeholder: '모집인원', type: 'number', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'reqNum', placeholder: '신청인원', type: 'number', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'sttNum', placeholder: '수강인원', type: 'number', value: '', visible: false, canSrch: false, selList: [] },
    { field: 'selCode', placeholder: '선발방식', type: 'select', value: '', visible: detailScreen, canSrch: false, selList: selCodeList },
    { field: 'selCodeName', placeholder: '선발방식', type: 'select', value: '', visible: !detailScreen, canSrch: false, selList: selCodeList },
    { field: 'statCode', placeholder: '상태', type: 'select', value: '', visible: detailScreen, canSrch: false, selList: statCodeList },
    { field: 'statCodeName', placeholder: '상태', type: 'select', value: '', visible: !detailScreen, canSrch: false, selList: [] },
    { field: 'studentNames', placeholder: '학생이름', type: 'text', value: '', visible: !detailScreen, canSrch: false, selList: [] },
    { field: 'regTime', placeholder: '등록일시', type: 'text', value: '', visible: false, canSrch: false, selList: [] },
    { field: 'uptTime', placeholder: '수정일시', type: 'text', value: '', visible: false, canSrch: false, selList: [] },
    { field: 'content', placeholder: '내용', type: 'textarea', value: '', visible: detailScreen, canSrch: false, selList: [] },
    { field: 'feeList', placeholder: 'feeList', type: 'array', value: [], visible: false, canSrch: false, selList: [] },
  ];
  // const [fields, set_fields] = useState([...defFields])

  const gdnFields = [
    { field: 'name', placeholder: '성명' },
    { field: 'loginId', placeholder: 'ID' },
    { field: 'phone', placeholder: '전화번호' },
    { field: 'phoneCertYn', placeholder: '인증여부' },
  ];

  const visibleColumns = fields.filter(col => col.visible);
  const defRecord = {};
  fields.forEach(d => {
    defRecord[d.field] = d.value;
  });

  const defTerms = {};
  fields
    .filter(col => col.canSrch)
    .map(d => d.field)
    .forEach(d => (defTerms[d] = ''));
  const [record, set_record] = useState(defRecord);
  const [dataList, set_dataList] = useState([]);

  const [skipPageReset, setSkipPageReset] = React.useState(false);
  const [openSnackbar, renderSnackbar] = useSnackbar();
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator();
  const dgHandler = useState(false);
  const [selIdx, set_selIdx] = useState(-1);
  const [pageNum, set_pageNum] = useState(0);
  const [pageSize, set_pageSize] = useState(10);
  const [totalCount, set_totalCount] = useState(0);
  const [pageInfo, set_pageInfo] = useState({ pageNum: 0, pageSize: -1 });
  const [terms, _set_terms] = useState(defTerms);
  const [fontSize, set_fontSize] = useState(12);
  const termsRef = useRef(terms);
  const [origin, set_origin] = useState('')
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer);
  const codes = useSelector(state => state.codeReducer);
  const schools = useSelector(state => state.schoolReducer);
  const account = useSelector(state => state.accountReducer);
  const schola = useSelector(state => state.scholaReducer);

  const defLschList = useMemo(() => {
    const lschList = [];
    const lsch = {
      id: -1,
      lectureId: -1,
      weekCode: '-1',
      startTime: null,
      endTime: null,
    };

    codes
      .filter(c => c.codeGroupId === g_week_code)
      .forEach(w => {
        lschList.push({ ...lsch, weekCode: w.code });
      });

    return lschList;
  });

  const ltgList = useMemo(() => {
    const ltgList = [];
    const ltg = {
      id: -1,
      lectureId: -1,
      grade: -1,
    };
    for (let i = 1; i < 7; i++) {
      ltgList.push({ ...ltg, grade: i });
    }
    return ltgList;
  });

  const set_terms = data => {
    termsRef.current = data;
    _set_terms(data);
  };

  const onLoad = async() => {
    openIndicator()
    //
    const smst = await fetchSmst()
    smstRef.current = smst

    //
    const studentList = await fetchStudents()
    set_studentList(studentList)
    //
    const regiList = await fetchRegis(smst.id)

    //
    const dataList = await fetchLectures(smst.id)
    dataList.forEach(lecture => {
      lecture.studentNames = ''
      const regis = regiList.filter(regi => regi.lectureId === lecture.id)
      regis.forEach(regi => {
        const student = studentList.find(r => r.id === regi.studentId)
        if(student) {
          if(lecture.studentNames) {
            lecture.studentNames = `${lecture.studentName},${student.name}`
          }
          else {
            lecture.studentNames = student.name
          }
        }
      })
    })
    set_dataList(dataList)


    closeIndicator()
  }

  const fetchSmst = async () => {
    const url = `/smst/last/${schola.id}`
    const resp = await WebService.get(url)
    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const record = JSON.parse(repMessage.record)
      return record
    }
    else {
      openSnackbar(resp.repMessage)
    }
  }

  const fetchLectures = async (smstId) => {
    let url = `/lecture/extra/smst/${smstId}`;
    const newTerms = {};
    Object.keys(termsRef.current).forEach(key => {
      if (termsRef.current[key] !== '') {
        newTerms[key] = termsRef.current[key];
      }
    });

    let tempList;
    let resp = await WebService.get(url, {
      pageNum: pageInfo.pageNum,
      pageSize: pageInfo.pageSize,
      terms: JSON.stringify(newTerms),
    });

    if (resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage);
      const originList = JSON.parse(repMessage.records);
      if(repMessage.totalCount) {
        const totalCount = repMessage.totalCount;
        set_totalCount(totalCount);
      }
      
      const records = originList.reduce((acc, cur, idx, arr) => {
        const lecture = cur.lecture;
        lecture.smstId = cur.smst.id;
        lecture.year = cur.smst.year;
        lecture.gisu = cur.smst.gisu;
        lecture.teacherName = cur.teacher.name;
        lecture.userId = cur.teacher.id;

        // lecture.teacherName = arr[idx].teacher.name
        // lecture.userId = arr[idx].teacher.id

        acc.push(lecture);
        return acc;
      }, []);

      records.forEach(r => {
        r.isDetail = false
        r.weekCodeList = []
        r.lschList = defLschList
        r.ltgList = []
        r.feeCodeList = []
      });

      // set_dataList(records)
      tempList = records;
    }

    // tempList.forEach(temp => {
    //   const found = schools.find(d => d.id === temp.schoolId);
    //   if (found) {
    //     temp.schoolId = found.id;
    //     temp.schoolName = found.name;
    //   }
    // });


    // 코드
    let records;
    records = codes.filter(c => c.codeGroupId === g_sel_code);
    records.forEach(r => {
      r.id = r.code;
    });
    records.unshift({ id: -1, name: '선발방식 선택' });
    set_selCodeList(records);
    tempList.forEach(temp => {
      const found = records.find(d => d.id === temp.selCode);
      if (found) {
        temp.selCodeName = found.name;
      }
    });

    records = codes.filter(c => c.codeGroupId === g_stat_code);
    records.forEach(r => {
      r.id = r.code;
    });
    records.unshift({ id: -1, name: '상태 선택' });
    set_statCodeList(records);
    tempList.forEach(temp => {
      const found = records.find(d => d.id === temp.statCode);
      if (found) {
        temp.statCodeName = found.name;
      }
    });

    records = codes.filter(c => c.codeGroupId === g_week_code);
    records.forEach(r => {
      r.id = r.code;
    });

    set_weekCodeList(records);

    return tempList
    //
    // const smstGroup = tempList.reduce((acc, cur) => {
    //   const key = '' + cur.year + '/' + cur.gisu;
    //   if (acc[key]) {
    //     acc[key].push(cur);
    //   } else {
    //     acc[key] = [cur];
    //   }
    //   cur.groupId = key;
    //   return acc;
    // }, {});

    // return smstGroup
  };

  const fetchStudents =  async() => {
    const url = `/student/gdn/phone/school/${account.user.phone}/${schola.id}`
    const resp = await WebService.get(url)
    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      return records
    }
    else {
      openSnackbar(resp.repMessage)
    }
  }

  const fetchRegis = async(smstId) => {
    const url =`/regi/smst/gdn/${smstId}/${account.user.id}`
    const resp = await WebService.get(url)
    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      return records
    }
    else {
      openSnackbar(resp.repMessage)
    }
  }


  const onDetail = async (groupId, lectureId) => {
    
    let url;
    let resp;

    url = `/lecture/lsch/ltg`;
    resp = await WebService.get(url, { lectureId: lectureId });
    if (resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage);
      const lschs = JSON.parse(repMessage.lschs);
      const ltgs = JSON.parse(repMessage.ltgs);
      const attchs = JSON.parse(repMessage.attchs);
      const fees = JSON.parse(repMessage.fees);
      printVariable('fees', fees)

      // set_files(attchs)
      const newDataList = { ...dataList };
      const lecture = newDataList[groupId].find(d => d.id === lectureId);

      const tempWeekCodeList = [];
      lschs.forEach(lsch => {
        const weekCode = weekCodeList.find(w => w.code === lsch.weekCode);
        tempWeekCodeList.push(weekCode);

        const localLsch = lecture.lschList.find(lsch2 => lsch2.weekCode === lsch.weekCode);
        localLsch.startTime = `2000-01-01 ${lsch.startTime}:00`;
        localLsch.endTime = `2000-01-01 ${lsch.endTime}:00`;
      });

      lecture.weekCodeList = tempWeekCodeList;

      // 학년
      lecture.ltgList = ltgs;

      // 첨부
      lecture.attchs = attchs;
      set_dataList(newDataList);

      // 요금
      lecture.feeList = fees
    }
    
    set_detailScreen(true);
    dgHandler[1](true);
  };

  const onSchedule = async id => {};

  const onDelete = async id => {
    const url = `/lecture`
    const resp = await WebService.delete(url, { id: id });
    if (resp.repCode === 'ack') {
      onLoad();
      openSnackbar('삭제되었습니다.');
    } else {
      openSnackbar(resp.repMessage);
    }
  };

  const onCreate = async () => {
    const schoolId = schola.id;
    const url = `/smst/active/${schoolId}`;
    const resp = await WebService.get(url, {});
    if (resp.repCode !== 'ack') {
      openSnackbar(resp.repMessage);
      return;
    }
    const repMessage = JSON.parse(resp.repMessage);
    const smst = JSON.parse(repMessage.smst);

    const now = moment().format(dateFormat);
    const newRecord = {
      ...defRecord,
      reqNum: 0,
      sttNum: 0,
      statCode: 'S001',
      regTime: now,
      uptTime: now,
    };
    newRecord.weekCodeList = [];
    newRecord.lschList = defLschList;
    newRecord.ltgList = [];
    newRecord.attchs = [];
    newRecord.feeList = []

    newRecord.smstId = smst.id;
    newRecord.groupId = `${smst.year}/${smst.gisu}`;

    set_record(newRecord);
    set_detailScreen(true);
    dgHandler[1](true);
  };

  const onSearch = () => {
    onLoad();
  };

  const onClear = () => {
    const obj = {};
    Object.keys(terms).forEach(k => {
      obj[k] = '';
    });
    set_terms(obj);
  };

  const onRegis = async () => {
    const url = `/regi/school/${schola.id}`
    const resp = await WebService.post(url, record)
    if(resp.repCode === 'ack') {
      openSnackbar('신청되었습니다.')
      onLoad()
    }
    else {
      openSnackbar(resp.repMessage)
    }

  }

  const handleChangePage = (event, newPage) => {
    set_pageInfo({ ...pageInfo, pageNum: newPage });
  };

  const handleChangeRowsPerPage = event => {
    const pageSize = parseInt(event.target.value, 10);
    set_pageInfo({ pageNum: 0, pageSize: pageSize });
  };

  const TablePaginationActions = props => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = event => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = event => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = event => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = event => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label='first page'>
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label='previous page'>
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label='next page'>
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label='last page'>
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

  useEffect(() => {
    onLoad();
  }, [pageInfo]);

  useEffect(() => {
    const size = window.getComputedStyle(inputRef.current, null).getPropertyValue('font-size');

    set_fontSize(size);
  }, []);

  const dg_title = '강좌 정보';
  // const memo_DgContent = useMemo(() => {
  //   return <ManagerLecturePart fields={fields} record={record} reload={onLoad} />;
  // }, [record]);

  if (dataList != null) {
    return (
			<div ref={inputRef}>
				<MyDialog
					title={dg_title}
					component={{}}
					dialogHandler={dgHandler}
					callback={() => {
						set_detailScreen(false)
					}}
				/>
        <GdnLecturePartRegi record={record} studentList={studentList} open={open} onClose={() => set_open(false)} reload={onLoad} origin={origin}/>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						justifyContent: "center",
					}}>
					<Typography component='h1' variant='h5' align={"center"}>
						수강신청 강좌 목록
					</Typography>
				</div>

				<div style={{ paddingTop: 20 }}>
					<MUITable>
						<MyTableHead>
							<TableRow>
								{fields.map((col, index2) => {
									if (col.visible) {
										return (
											<TableCell key={index2} size='small' key={col.field}>
												{col.placeholder}
												{col.canSrch ? (
													<Fragment>
														<TextField
															label=''
															variant='outlined'
															size='small'
															inputProps={{
																style: {
																	fontSize: "0.875em",
																	padding: 5,
																	backgroundColor: "#fff",
																},
															}}
															value={terms[col.field]}
															onChange={(e) => {
																const newTerms = { ...terms }
																newTerms[col.field] = e.target.value
																set_terms(newTerms)
															}}
														/>
													</Fragment>
												) : (
													<Fragment>
													</Fragment>
												)}
											</TableCell>
										)
									}
								})}
								<TableCell size='small'>
								</TableCell>
							</TableRow>
						</MyTableHead>
						<TableBody>
            {dataList.map((row, index) => {
              return (
                <TableRow
                  sx={{backgroundColor: row.statCode ==='S004' ? '#ffebee': null }}
                  key={index}
                  onClick={() => {
                    set_selIdx(index)
                    set_record(row)
                  }}>
                  {fields.map((col, index2) => {
                    if (col.visible && col.field !== "smstName") {
                      return (
                        <TableCell key={index2} size='small'>
                          {row[col.field]}
                        </TableCell>
                      )
                    }
                  })}
                  <TableCell size='small'>
                    <Button variant='outlined' size='small' style={{ marginRight: 5 }} onClick={() => {}}>
                      상세 보기
                    </Button>
                    <Button variant='outlined' size='small' style={{ marginRight: 5 }} onClick={() => {}}>
                      내역 보기
                    </Button>
                    <Button
                      variant='outlined' size='small' style={{ marginRight: 5 }} color='primary'
                      disabled={row.studentNames || row.statCode === 'S004' || row.phase !== 1}
                      onClick={() => {
                        set_origin('req')
                        set_open(true)
                      }}>
                      수강신청 하기
                    </Button>
                    <Button variant='outlined' size='small' style={{ marginRight: 5 }} color='warning' disabled={!row.studentNames} onClick={() => {
                      set_origin('can')
                      set_open(true)
                    }}>
                      수강신청 취소하기
                    </Button>
                  </TableCell>
                </TableRow>
              )
            })}
						</TableBody>
						<TableFooter>
							<TableRow>
								<TablePagination
									rowsPerPageOptions={[10, 20, { label: "All", value: -1 }]}
									colSpan={visibleColumns.length + 1}
									count={totalCount}
									rowsPerPage={pageInfo.pageSize}
									page={pageInfo.pageNum}
									SelectProps={{
										inputProps: {
											"aria-label": "rows per page",
										},
										native: true,
									}}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
									ActionsComponent={TablePaginationActions}
									labelDisplayedRows={({ from, to, count }) => {
										// return '' + from + '-' + to + ' 개 ' + count
										return `${from} - ${to} of ${count}`
									}}
									labelRowsPerPage={"페이지당 갯수"}
								/>
							</TableRow>
						</TableFooter>
					</MUITable>
					{renderSnackbar()}
					{renderIndicator()}
				</div>
			</div>
		)
  }
};

export default GdnLecturePage;
